
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/focused-sankey-node",
      function () {
        return require("private-next-pages/x/api/charts/focused-sankey-node.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/focused-sankey-node"])
      });
    }
  